module.exports = __webpack_public_path__ + "static/media/vLogo.f57c1363.png";